import { Stack, StackProps, Typography } from '@mui/material';
import React from 'react';

type CollectionSectionHeaderProps = {
  icon: React.ReactElement;
  title: string;
  fontWeight?: number;
} & StackProps;

export const CollectionSectionHeader = ({
  icon,
  title,
  fontWeight = 400,
  ...stackProps
}: CollectionSectionHeaderProps) => {
  return (
    <Stack direction='row' spacing={1} alignItems='flex-start' {...stackProps}>
      {React.cloneElement(icon, { fontSize: 'small', color: 'primary' })}
      <Typography variant='subtitle2' sx={{ fontWeight }}>
        {title}
      </Typography>
    </Stack>
  );
};
